import type { ReactNode } from 'react';

/**
 * Field label followed by the required asterisk. The label text and the
 * asterisk share one element on purpose: `FormLabel` lays its children out with
 * `flex … gap-2`, which would otherwise push a sibling asterisk to the far end
 * of the row.
 *
 * @param props.children - the label text
 * @returns the label element
 */
export const RequiredLabel = ({ children }: { children: ReactNode }) => (
  <span>
    {children}
    <span
      className="ml-0.5 text-destructive"
      aria-hidden="true"
    >
      *
    </span>
  </span>
);
